//
import { Typography } from '@mui/material';
import Image from '../../image';
//
import { CustomFile } from '../types';
import FileThumbnail from 'src/components/file-thumbnail';

// ----------------------------------------------------------------------

type Props = {
  file: CustomFile | string | null;
};

export default function SingleFilePreview({ file }: Props) {
  if (!file) {
    return null;
  }

  const imgUrl = typeof file === 'string' ? file : file.preview;
  const name = typeof file !== 'string' ? file.name : null;
  const fileType = typeof file !== 'string' ? file.type : null;

  return (
    <>
      {
        fileType?.includes('image') ?
          <Image
            alt="file preview"
            src={imgUrl}
            sx={{
              top: 8,
              left: 8,
              zIndex: 8,
              borderRadius: 1,
              position: 'absolute',
              width: 'calc(100% - 16px)',
              height: 'calc(100% - 16px)',
              objectFit: 'contain !important'
            }}
            innerSx={{ objectFit: 'contain', height: '90%' }}
          /> :
          <FileThumbnail
            tooltip
            imageView
            file={file}
            sx={{ position: 'absolute' }}
            imgSx={{ position: 'absolute' }}
          />
      }

      {name && <span style={{ fontSize: '100%', position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', textAlign: 'center' }}>
        {name}
      </span>}
    </>
  );
}
